import {Pipe, PipeTransform} from '@angular/core';
import {UserService} from '../services/user.service';

@Pipe({
    name: 'user'
})
export class UserPipe implements PipeTransform {
    constructor(private userService: UserService) {}

    transform(id: number): any {
        const users = this.userService.getUser();
        return users.filter(user => user.id === id)[0].user_name;
    }
}
